import {useCallback, useState} from 'react'

const useLoadingClick = ({onClick}) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleOnClick = useCallback(
    async event => {
      if (onClick && !isLoading) {
        try {
          setIsLoading(true)
          await onClick(event)
        } finally {
          setIsLoading(false)
        }
      }
    },
    [onClick, isLoading]
  )

  return {
    handleOnClick,
    isLoading,
  }
}

export default useLoadingClick
